import { Store } from "../core/bear";

export default new Store({
  photo: 'https://imgur.com/G9gZ44d.png',
  name: 'Lim SeungYi',
  email: 'evxrafter@gmail.com',
  github: 'https://github.com/doitidey',
  repository: 'https://github.com/doitidey/MovieApp'
})